<template>
    <div class="table_wrap">
        <el-table
                :data="List"
                style="width: 100%"
                empty-text="데이터가 없습니다."

        >
            <el-table-column label="회차번호" prop="st_term" class-name="text-center"></el-table-column>
            <el-table-column
                    label="회차상태" width="150" class-name="text-center">
                <template slot-scope="scope">
                        <span>
                            {{subscribeStatusName(scope.row.st_status, scope.row.days)}}
                        </span>
                </template>
            </el-table-column>

            <el-table-column label="상품명" prop="o_name" class-name="text-center"></el-table-column>
            <el-table-column
                    label="금액" width="150" class-name="text-center">
                <template slot-scope="scope">
                        <span>
                            ${{scope.row.o_price}}
                        </span>
                </template>
            </el-table-column>
            <el-table-column label="결제번호" prop="o_id" class-name="text-center"></el-table-column>
            <el-table-column
                    label="결제일" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{returnDate(scope.row.created_at)}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                    label="" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        <el-button v-if="scope.row.st_status === 1" @click="openCloseSubscribe(scope.row.s_idx)" type="info" size="mini">구독강제종료</el-button>
                    </span>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagnation_wrap">
            <el-pagination v-if="filterSet.page.total > 0"
                           :page-size="filterSet.page.size"
                           :current-page.sync="filterSet.page.page"
                           :pager-count="11"
                           layout="prev, pager, next"
                           :total="filterSet.page.total"
                           @current-change="changePage('page', filterSet.page.page)"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
    import VuxAlert from "@/mixins/vux-alert";
    import listMixins from "@/mixins/listMixins";
    import filterMixins from "@/mixins/filterMixins";
    import util from "@/mixins/util";
    import {subscribeStatus} from "@/service/subscribeService";

    export default {
        name: 'MemberSubscribeComponent',
        mixins: [VuxAlert, filterMixins, listMixins],
        components: {
        },
        props: {
            memberKey: {

            },
        },
        data() {
            return{

            }
        },
        created() {
            this.setParserType('url', this.$route.fullPath);
            let listOptions = {
                url : this.$api.$subscribe.getSubscribe,
                defaultParams : {
                    ip: 1,
                    no: this.memberKey,
                },
            }
            this.initList('api', listOptions);
        },
        mounted() {
            this.isInitPage = true;
            this.getList();
        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
        },
        methods:{
            tableIdx(index) {
                return this.filterSet.page.total - index - (this.filterSet.page.page - 1) * this.filterSet.page.size;
            },
            returnDate(date=null) {
                if(!date) {
                    return '';
                }
                return this.$moment.unix(date).format('YYYY-MM-DD HH:mm')
            },
            subscribeStatusName(status, days) {
               if(status === 0) {
                   return '대기'
               }else if(status == 1) {
                   if(!util.isNumber(days) || days < 0) {
                       return '완료';
                   }
                   return '진행중'
               }else if(status == 3) {
                   return '구독종료'
               }else if(status -1) {
                   return '실패';
               }
               return '';
            },
            openCloseSubscribe(s_idx) {
                this.createConfirm({
                    title: '',
                    content: '정말 구독강제종료하시겠습니까?',
                    confirmText: '확인',
                    cancelText: '취소',
                    confirm: () => {
                        this.runCloseSubscribe(s_idx);
                    }
                })
            },
            runCloseSubscribe(s_idx) {
                let params = {
                    s_idx: s_idx,
                    mb_no: this.memberKey,
                }
                try {
                    this.$api.$subscribe.exitSubscribe(params).then(res => res.Data.Result).then(res => {
                        let type = this.returnCloseSubscribeType(res.Info.type);
                        if(type === true) {
                            this.createAlert({
                                title: '',
                                content: '구독이 강제종료되었습니다.',
                                btnText: '확인',
                                hide: () => {
                                    this.getList();
                                }
                            })
                        }else{
                            this.errorAlert(type)
                        }
                    })
                }catch (e) {
                    console.log(e);
                }
            },
            returnCloseSubscribeType(type) {
                switch (type) {
                    case 1:
                        return true;
                    case -401:
                        return '해당 회원은 구독상태가 아닙니다.';
                    default:
                        return "구독 강제종료에 실패하였습니다."
                }
            }
        },
        watch: {

        },
    }
</script>
